export default "__VITE_ASSET__4d3fe1da__"